var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-edit"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    clipPath: "url(#clip-edit)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit-2",
    "data-name": "edit",
    transform: "translate(0.547 0.045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34065",
    "data-name": "Path 34065",
    d: "M14.971,92.12a.788.788,0,0,0-.788.788v6.3A.789.789,0,0,1,13.4,100H2.364a.789.789,0,0,1-.788-.788V88.18a.789.789,0,0,1,.788-.788h6.3a.788.788,0,0,0,0-1.576h-6.3A2.367,2.367,0,0,0,0,88.18V99.212a2.367,2.367,0,0,0,2.364,2.364H13.4a2.367,2.367,0,0,0,2.364-2.364v-6.3A.787.787,0,0,0,14.971,92.12Zm0,0",
    transform: "translate(0 -82.168)",
    fill: "#7f8694"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34066",
    "data-name": "Path 34066",
    d: "M182.481,74.5a.4.4,0,0,0-.108.2l-.557,2.786a.394.394,0,0,0,.387.471.375.375,0,0,0,.077-.008l2.785-.557a.392.392,0,0,0,.2-.108l6.234-6.234-2.785-2.785Zm0,0",
    transform: "translate(-175.097 -65.258)",
    fill: "#7f8694"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34067",
    "data-name": "Path 34067",
    d: "M395.321,1.077a1.971,1.971,0,0,0-2.785,0l-1.09,1.09,2.785,2.785,1.09-1.091a1.97,1.97,0,0,0,0-2.785Zm0,0",
    transform: "translate(-376.991)",
    fill: "#7f8694"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.34d1469ccc7a13671de9c24a63f039ef.svg";
export { ForwardRef as ReactComponent };